var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgLogoWithoutText(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 56,
    height: 56,
    viewBox: "0 0 56 56",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Logo without text"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Vector"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M24.2786 14.4211V34.6965H29.3275V30.1862H30.9503C36.991 30.1862 39.6507 27.3815 39.6507 22.5786C39.6507 16.575 35.864 14.4211 30.9503 14.4211C27.1276 14.421 26.803 14.4211 24.2786 14.4211ZM29.3275 19.4622V25.0992H30.9503C32.3929 25.0992 34.5567 25.2826 34.5567 22.3036C34.5567 19.3247 32.2126 19.4622 30.9503 19.4622H29.3275Z",
    fill: "#0E492E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M17.5343 14.4211V41.5059H38.9021V36.4189H22.5833V14.4211H17.5343Z",
    fill: "#0E492E"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M27.6003 50.2353C39.7052 50.2353 49.5182 40.2802 49.5182 28C49.5182 15.7198 39.7052 5.76473 27.6003 5.76473C15.4954 5.76473 5.68244 15.7198 5.68244 28C5.68244 40.2802 15.4954 50.2353 27.6003 50.2353ZM27.6003 51.8824C40.6019 51.8824 51.1417 41.1899 51.1417 28C51.1417 14.8102 40.6019 4.11767 27.6003 4.11767C14.5987 4.11767 4.05889 14.8102 4.05889 28C4.05889 41.1899 14.5987 51.8824 27.6003 51.8824Z",
    fill: "#0E492E"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M27.6003 54.3529C41.9468 54.3529 53.577 42.5543 53.577 28C53.577 13.4457 41.9468 1.64706 27.6003 1.64706C13.2537 1.64706 1.62355 13.4457 1.62355 28C1.62355 42.5543 13.2537 54.3529 27.6003 54.3529ZM27.6003 56C42.8435 56 55.2006 43.464 55.2006 28C55.2006 12.536 42.8435 0 27.6003 0C12.3571 0 0 12.536 0 28C0 43.464 12.3571 56 27.6003 56Z",
    fill: "#0E492E"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogoWithoutText);
export default __webpack_public_path__ + "static/media/logo_without_text.4619c69b5043c1ec4b67d1316f96d5a1.svg";
export { ForwardRef as ReactComponent };